export default __webpack_public_path__ + "static/media/cookie-policy.a3936420.md";